import { doodBlockConfig } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ACCOUNTPAGE_LEGACY_FIELD_ORDER = [
  
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  accountPageDescriptor: _generatedAccountPageDescriptor,
  accountPageBlocDefinition,
  accountPageDashboardLayout,
  accountPageConfig,
  accountPageResolveConfig,
  accountPageProperties,
} = doodBlockConfig(
  {
    name: "User account page",
    internal_name: "User account page",
    url: "account",
    defaultParent: [/^Main Layout$/i],
    componentType: 'AccountPageComponent',
    category: 'page',
    description: "User account page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.account-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'header-block', type: 'HeaderBlockComponent' },
          { id: 'account-block', type: 'AccountPageBlockComponent' },
        ],
      },
      {
        key: 'footer',
        name: "pages.blocks.account-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.account-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.account-page.fieldset.blocks.label",
            fields: ["body", "footer"],
          },
        ],
      },
    ],
  })
);

export function accountPageDescriptor(): IBlockDescriptor;
export function accountPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function accountPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedAccountPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedAccountPageDescriptor, accountPageProperties, fieldOrder);
}

export {
  accountPageBlocDefinition,
  accountPageDashboardLayout,
  accountPageProperties,
  accountPageConfig,
  accountPageResolveConfig,
};

export type AccountPageConfig = typeof accountPageConfig;
